import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

class index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
    };
  }

  handleChange = (event, value, id) => {
    this.setState({ value, id }, () => {});
  };

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const {} = this.props;
    const {} = this.state;
    return (
      <div className="innerwrapper-full-width">
        <div className="content-outer-wrapper">
          <Grid container>
            <Grid
              item
              xs={12}
              md={10}
              sm={2}
              justify="flex-end"
              className="display-flex"
            ></Grid>
          </Grid>
        </div>
      </div>
    );
  }
}
const mapStateToProps = () => ({});

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(withSnackbar(index)),
);
